import React from "react";
import cookie from "react-cookies";
import { Button, Input, message, Modal, Alert } from "antd";
import { post } from "../../../helper/request";
import "../../../asset/style/settings/manageusers/change_password.css";

class EnabledTotp extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            errorFlag: false,
            errorMessage: "",
            totpInput: "",
            showTotpSetupKey: false,
            showRecoveryTotpCodes: false,
            recoveryTotpCodes: null,
        };
    }

    componentDidMount() {
        document.addEventListener("keydown", this.handleKeyDown);
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeyDown);
    }

    handleKeyDown = (e) => {
        if (e.key === "Enter" && this.props.modalVisible) {
            e.preventDefault();
            if ((!this.props.isTotpEnabledUserAccount) && this.state.totpInput.length > 0) {
                this.handleVerifyTotp();
            }
        }
    };

    handleTotpInputChange = (e) => {
        this.setState({
            totpInput: e.target.value,
        });
    };

    handleCancel = () => {
        this.props.closeModal();
        this.setState({
            isFetching: false,
            errorFlag: false,
            errorMessage: "",
            totpInput: "",
            showTotpSetupKey: false,
        });
    };
    handleGenerateCodes = () => {
        post("/api/generate_totp_recovery_codes/")
            .then((response) => {
                const { recovery_codes: recoveryCodes } = response;    
                this.setState({
                    recoveryTotpCodes: recoveryCodes,
                });
                this.downloadRecoveryCodes(recoveryCodes);
                this.setState({
                    showRecoveryTotpCodes: true,
                })
            })
            .catch((error) => {
                message.error("Error fetching recovery codes. Please try again.");
            });
    };

    downloadRecoveryCodes = (codes) => {
        const blob = new Blob([codes.join("\n")], { type: "text/plain" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        let downloadUserName = cookie.load("username");
        if (downloadUserName === undefined) {
            downloadUserName = "";
        } else {
            downloadUserName = "_" + downloadUserName;
        }
        link.download = "morhple-recovery-codes" + downloadUserName + ".txt";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    handleVerifyTotp = () => {
        const { totpInput } = this.state;
        post("/api/verify_totp/", { totp_code: totpInput })
            .then((response) => {
                if (response.success) {
                    message.success(response.message);
                    
                    this.setState({
                        totpInput: "",
                    });
                    this.handleGenerateCodes();
                    this.props.enableTotpSuccess();
                } else {
                    message.error(response.message);
                }
            })
            .catch((error) => {
                message.error(error.response.data.message);
            });
    };

    toggleShowTotpSetupKey = () => {
        this.setState({ showTotpSetupKey: !this.state.showTotpSetupKey });
    };

    render() {
        const { totpUri } = this.props;
        const secretMatch = totpUri.match(/secret=([^&]+)/);
        const secret = secretMatch ? secretMatch[1] : "";

        return (
            <Modal
                title="Enable TOTP"
                visible={this.props.modalVisible}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                footer={[
                    <div key="footer">
                        {this.state.showRecoveryTotpCodes ? (
                            <Button key="close" onClick={this.handleCancel}>
                                Close
                            </Button>
                        ) : (
                            <Button key="verify" type="primary" onClick={this.handleVerifyTotp} disabled={!(this.state.totpInput.length > 0)}>
                                Verify
                            </Button>
                        )}
                    </div>,
                ]}>
                {this.state.showRecoveryTotpCodes ? (
                    <div>
                        <Alert
                            message="Verification successful! Recovery codes have been generated and downloaded."
                            type="success"
                            showIcon
                        />
                        <div style={{ backgroundColor: '#f0f0f0', padding: '16px', borderRadius: '8px', marginTop: '16px' }}>
                            <h2>Recovery Codes</h2>
                            <ul>
                                {this.state.recoveryTotpCodes.map((code, index) => (
                                    <li key={index}>{code}</li>
                                ))}
                            </ul>
                        </div>
                        <div style={{ marginTop: 16, padding: 5}}>
                            <p style={{ marginBottom: 0 }}>
                                <strong>Keep your recovery codes in a safe spot.</strong> These codes are the last resort for accessing your account in case you lose your password and second factors.
                            </p>
                        </div>
                    </div>
                    ) : (
                    <>
                    <p>
                        <h2>Setup authenticator app:</h2>
                        Authenticator apps and browser extensions like{" "}
                        <a
                            href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en&gl=US"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Google Authenticator
                        </a>
                        ,{" "}
                        <a
                            href="https://learn.microsoft.com/en-us/azure/active-directory/user-help/multi-factor-authentication-end-user-app-passwords"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Microsoft Authenticator
                        </a>
                        ,{" "}
                        <a href="https://support.1password.com/one-time-passwords/" target="_blank" rel="noopener noreferrer">
                            1Password
                        </a>
                        ,{" "}
                        <a href="https://authy.com/" target="_blank" rel="noopener noreferrer">
                            Authy
                        </a>
                        , etc. generate one-time passwords that are used as a second factor to verify your identity when prompted during sign-in.
                    </p>

                    {this.props.totpUri !== "" ? (
                        <div>
                            <h2>Scan the QR code</h2>
                            <p>Use an authenticator app or browser extension to scan the QR code and enter the TOTP below:</p>
                            <div
                                style={{
                                    textAlign: "center",
                                    paddingBottom: "24px",
                                    paddingTop: "10px",
                                }}
                            >
                                <img
                                    src={`data:image/png;base64,${this.props.qrCode}`}
                                    alt="QR Code"
                                    style={{ width: 250, height: 250 }}
                                />
                            </div>
                            
                        </div>
                    ) : (
                        <p>No QR code available</p>
                    )}
                    <p>
                        Unable to scan? You can use the{" "}
                        <a href="#" onClick={this.toggleShowTotpSetupKey}>
                            setup key
                        </a>{" "}
                        to manually configure your authenticator app.
                    </p>
                    {this.state.showTotpSetupKey && (
                        <div
                            style={{
                                border: "1px solid #d9d9d9",
                                backgroundColor: "#f0f0f0",
                                borderRadius: 5,
                                padding: "5px",
                                marginBottom: 14,
                            }}
                        >
                            <strong>Your Two-Factor Secret:</strong>
                            <br />
                            {secret}
                        </div>
                    )}

                    <Input placeholder="Enter TOTP code" value={this.state.totpInput} onChange={this.handleTotpInputChange} />
                    </>
                )
              }
            </Modal>
        );
    }
}

export default EnabledTotp;
